import { css } from 'linaria';

export const downloadCatalogCartItem = css`
  grid-row-start: 3;

  @media (--only-mobile) {
    grid-row-start: 2;
  }
`;

export const downloadCatalogCart = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);

  &:hover {
    background-color: var(--control-minor);
  }
`;
